import React from 'react';
import { TableCell, Typography } from '@mui/material';
import { formatValueWithResolution, formatDisplayValue } from './utils';

type ToleranceCellProps = {
  tolerance: number;
  resolution?: number;
  unit: string;
};

export const ToleranceCell: React.FC<ToleranceCellProps> = ({
  tolerance,
  resolution,
  unit
}) => (
  <TableCell>
    <Typography variant="body2" fontWeight={600}>
      ±
      {resolution !== undefined
        ? formatValueWithResolution(tolerance, resolution)
        : formatDisplayValue(tolerance)}{' '}
      {unit}
    </Typography>
  </TableCell>
);
